<template>
    <div>
        <div v-if="!search">
            <div class="front-page" v-if="$store.state.user.token" :class="{xs: $vuetify.breakpoint.xs}">
                <img :class="{xs: $vuetify.breakpoint.xs}" class="footer absolute mt-12 pt-8" width="100%" src="@/assets/images/front/Vector 59.png">
                <!-- <div class="feeds mt-4">
                    <h3>Feeds:</h3>
                    <v-container v-if="feeds && feeds.length">
                        <v-row>
                            <v-col sm="6" lg="3" v-for="(feed, i) in feeds" :key="i">
                                <v-btn block @click="toFeed(feed)">{{feed.name}}</v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                    <div class="placeholder" v-else>
                        <div class="label text-center">You have not any feeds. <router-link to="/feeds">Add a new one</router-link> to be able to create notices!</div>
                    </div>
                </div> -->
                <ThemesList :items="themes"/>
                <div class="last-notices relative" :class="{xs: $vuetify.breakpoint.xs}" v-if="lastNotices && lastNotices.length">
                    <div class="last-header">
                        <div class="name text-center mt-12 ml-2 roboto-bold-24 ml-md-4 clr-black-38 pointer header-label" @click="$router.push('/feeds')">Быстрые заметки</div>
                        <div class="nav-buttons">
                            <button :disabled="!counterNotice" class="arrow-right-button mr-3" @click="toPrevNotice()" :class="{disabled: !counterNotice}">
                                <img height="35px" src="@/assets/images/components/arrow-left-white-blue.png">
                            </button>
                            <button :disabled="counterNotice >= lastNotices.length - lastItemsWidth" class="arrow-left-button" @click="toNextNotice()"  :class="{disabled: counterNotice >= last_notices.length - lastItemsWidth}">
                                <img height="35px" src="@/assets/images/components/arrow-right-white-blue.png">
                            </button>
                        </div>
                    </div>
                    <div class="flex-center mt-10">
                        <div class="notices" :class="{xs: $vuetify.breakpoint.xs}">
                            <Slider ref="lastNotices" v-model="counterNotice">
                                <div class="slider-item" v-for="(notice, i) in lastNotices" :key="notice._id">
                                    <ItemCard :notice="notice"/>
                                </div>
                            </Slider>
                        </div>
                    </div>
                </div>
                <div class="last-subs relative" v-if="lastSubs && lastSubs.length" :class="{mdAndUp: $vuetify.breakpoint.mdAndUp}">
                    <div class="last-header">
                        <div class="roboto-bold-24 ml-2 ml-md-12 clr-black-38 header-label">Последние заметки и задачи</div>
                        <div class="nav-buttons">
                            <button :disabled="!counterSub" class="arrow-right-button mr-3" @click="toPrevSub()" :class="{disabled: !counterSub}">
                                <img height="35px" src="@/assets/images/components/arrow-left-white-blue.png">
                            </button>
                            <button :disabled="counterSub >= lastSubs.length - lastItemsWidth" class="arrow-left-button" @click="toNextSub()"  :class="{disabled: counterSub >= last_subs.length - lastItemsWidth}">
                                <img height="35px" src="@/assets/images/components/arrow-right-white-blue.png">
                            </button>
                        </div>
                    </div>
                    <div class="flex-center mt-10">
                        <div class="subs">
                            <Slider ref="lastSubs" v-model="counterSub">
                                <div class="slider-item" v-for="(sub, i) in lastSubs" :key="i">
                                    <ItemCard :sub="sub" />
                                </div>
                            </Slider>
                        </div>
                    </div>
                </div>
                <!-- <a text id="download">Download</a>
                <div class="pointer" @click="notify">Notify me</div> -->
            </div>
            <Main v-else/>
            <cookie-consent :message="message" :linkLabel="linkLabel" :buttonLabel="buttonLabel"/>
        </div>
        <div class="search" v-if="$vuetify.breakpoint.xs && search">
            <div class="flex-center mt-8" @click="toPrevPage()">
              <img class="ml-7" src="@/assets/images/components/arrow-left-blue.svg">
              <div class="roboto-normal-18 clr-blue ml-2">Назад</div>
            </div>
            <SearchMobile/>
        </div>
    </div>
</template>

<script>
	import SubMain from './../main/SubMain'
	import Notice from './../feeds/Notice'
    import Main from '../main/home/Main'
    import SearchMobile from '../header/SearchMobile'
    import {mapGetters, mapMutations, mapActions} from 'vuex'
    import ThemesList from './ThemesList.vue'
    import ItemCard from '@/components/main/ItemCard.vue'
    import Slider from '@/components/misc/Slider.vue'

export default {
        name: 'FrontPage',
        components: {
            Slider,
            ItemCard,
            ThemesList,
            // ItemCard,
            SubMain,   
			Notice,
            Main,
            SearchMobile			
        },
        data() {
            return {
                arrowLeftNotice: false,
                arrowLeftSub: false,
                counterNotice: 0,
                counterSub: 0,
                animationNotice: false,
                animationSub: false,
                search: false,
                message: "Этот веб-сайт использует файлы cookie, чтобы обеспечить вам наилучший опыт работы на нашем веб-сайте.",
                linkLabel: "Узнать подробнее",   
                buttonLabel: "Ясно"        
            }
        },
        computed:{
            ...mapGetters(['themes', 'feeds', 'last_subs', 'last_notices']),
            lastNotices() {
                return this.last_notices.filter((el) => el && el.body && el.body.trim() && !el.completedInFeed).slice(0, 20)
            },
            lastSubs() {
                return this.last_subs.filter((el) => el && el.body && el.body.trim() && !el.completed).slice(0, 20)
            },
            lastItemsWidth(){
                if (this.$vuetify.breakpoint.lgAndUp) {
                    return 4
                } else if (this.$vuetify.breakpoint.mdOnly) {
                    return 3
                } else if (this.$vuetify.breakpoint.smOnly) {
                    return 2
                } else {
                    return 1
                }
            },
            lastSubsSlices(){
                const subs = this.last_subs.slice(0,20)
                if (this.$vuetify.breakpoint.lgAndUp) {
                    return subs.slice(this.counterSub,this.counterSub + 4)
                } else if (this.$vuetify.breakpoint.mdOnly) {
                    return subs.slice(this.counterSub,this.counterSub + 3)
                } else if (this.$vuetify.breakpoint.smOnly) {
                    return subs.slice(this.counterSub,this.counterSub + 2)
                } else {
                    return subs.slice(this.counterSub,this.counterSub + 1)
                }
            },
            dataJSON(){
                return JSON.stringify([this.themes, this.feeds])
            },
        },        
        methods: {
            ...mapMutations(['SET_CURRENT', 'SET_CURRENT_FEED']),
            ...mapActions(['setRelavantNotices']),
            notify(){
                    
            },
            toFeed(feed){
                this.SET_CURRENT_FEED(feed)
                this.feedBody = feed.body                
                this.$router.push('/feeds/' + feed.route_name)
            },
            toNextNotice() {
                this.$refs.lastNotices.right()
            },
            toPrevNotice() {
                this.$refs.lastNotices.left()
            },
            toNextSub() {
                this.$refs.lastSubs.right()
            },
            toPrevSub() {
                this.$refs.lastSubs.left()
            },
            toPrevPage() {
                this.search = false
            }
         },
        mounted() {
            this.$root.$on('search', () => { 
                this.search = true         
            })
            this.$root.$on('toHome', () => { 
                this.search = false        
            }) 
            this.$nextTick(async () => {                
                // setInterval(() => {         
                //     try {
                //         let myBlob = new Blob ([this.dataJSON], {
                //             type: 'application/json'
                //         });
                //         let myUrl = URL.createObjectURL(myBlob);
                //         download.href =  myUrl;
                //         download.download = 'taskmgr_archive.json';                        
                //     } catch (e) {
                //         true
                //     }           
                // }, 500)
            })
        },
}
</script>

<style lang="scss" scoped>
    .slider-item{
        width: 300px;
        margin-right: 20px;
    }
    .header-label{
        max-width: 70%;
    }
    .last-header{
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .notice{
        cursor: pointer;
    }
	.label{
		font-size: 14px;
	}
    .front-page{
        background: linear-gradient(180deg, #E0F1ED 0%, #DEFFE7 60.42%);
        padding: 0 0;
        &.xs {
            overflow: hidden;
        }
        .last-notices {
            margin-top: 130px;
            padding: 0 2%;
            &.xs {
                margin-top: 48px;
                padding-top: 20px;
                margin-bottom: 50px;
            }
            .name {
                max-width: 254px;
                box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
                border-radius: 29px;
                height: 43px;
                padding: 8px 20px;
                background: #FFFFFF;
            }
            .notices {
                display:flex;
                justify-content: space-between;
                align-items: center;
                width:100%;
                .notice {
                    background: #FFFFFF;
                    &.animationNotice {
                        transform: translateX(-100px);
                        transition: transform 1s;
                    }
                }
            }
            .arrow-right-button, .arrow-left-button {
                &.disabled{
                    filter: grayscale(1);
                }
            }
            .arrow-right {
                transform: rotate(180deg);
            }
        }
        .last-subs {
            margin-top: 120px;
            margin-bottom: 75px;
            padding: 0 2%;
            &.mdAndUp {
               margin-top: 170px;
            }
            .subs-width {
                width:96%;
            }
            .subs {
                display:flex;
                justify-content: space-between;
                align-items: center;
                width:100%;
                .arrow-right {
                    transform: rotate(180deg);
                }
                .sub {
                    background: #FFFFFF;
                    &.animationSub {
                        transform: translateX(-100px);
                        transition: transform 1s
                    }
                }
            }
            .arrow-right {
                transform: rotate(180deg);
            }
            .footer {
                &.xs {
                    position:fixed;
                    bottom:0
                }
            }
        }
    }
    .footer {
        bottom:0;
    }
</style>